/**
 * @file   src\components\Onboarding\UserRegister\CheckResetEmailModal.js
 * @brief  This file is responsible for showing resent email
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Col, Row } from "react-bootstrap";
import EmailResentModal from "./EmailResentModal";
import _ from "lodash";
import { resendEmail } from "../../../services/signupService";
import { resetPassword } from "../../../services/v2/loginService";

const CheckResetEmailModal = (props) => {
  const { email, show, process, onHide } = props;
  const [showResentPopup, setResentPopup] = useState(false);
  const [showCheckEmailPopup, setShowCheckEmailPopup] = useState(true);
  const [counter, setCounter] = useState(60);
  const isFromSettings = process === "ResetPwdFromSetting";
  /**
   * To handle resent email
   */
  const resentEmail = () => {
    const userInfo = {
      Email: email,
      Process: process,
    };

    resendEmail(userInfo).then((response) => {
      if (response) {
        if (_.get(response, "errorCode", false) === 0) {
          showResetSuccessPopup();
        }
      }
    });
  };

  /**
   * To handle password reset
   */
  const handleSubmit = async () => {
    let reqPayload = { email: email };
    await resetPassword(reqPayload).then((res) => {
      if (_.get(res, "errorCode", null) === 0) {
        toast.success("Link Sent Successfully");
      } else {
        toast.error("Error Sending the link");
      }
    });
  };
  useEffect(() => {
    if (show) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [counter, show]);

  const showResetSuccessPopup = () => {
    setShowCheckEmailPopup(false);
    setResentPopup(true);
  };

  return (
    <>
      <Modal
        show={show}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="pt-32 pb-32">
          {isFromSettings && (
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => onHide({ modalState: false })}
            ></button>
          )}

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => onHide({ modalState: false })}
          ></button>
          <h2 className="text-center">
            Check your {isFromSettings ? "inbox" : "email"}{" "}
          </h2>

          <Row>
            <Col xl={12}>
              <p className="mb-2 text-center">
                We've sent a reset link to <strong>{email}.</strong>
              </p>
              {isFromSettings ? (
                <p className="text-center">
                  Didn't get an email?{" "}
                  <strong>
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      {" "}
                      Resend email.
                    </a>
                  </strong>
                </p>
              ) : counter === 0 ? (
                <p className="text-center">
                  Didn't get an email?{" "}
                  <strong>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      {" "}
                      Let's try resending it.
                    </a>
                  </strong>
                </p>
              ) : (
                <p className="text-center">
                  Resend <strong>{counter} seconds.</strong>{" "}
                </p>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <EmailResentModal
        show={showResentPopup}
        centered
        email={email}
      ></EmailResentModal>
    </>
  );
};
export default CheckResetEmailModal;
